/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to merge speakers" |
*
* @param {Speaker_Manager_Merge_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_failed_toast = /** @type {((inputs?: Speaker_Manager_Merge_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec de la fusion des locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführen der Sprecher fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile unire gli altoparlanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось объединить динамики")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron fusionar los altavoces")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并发言者失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを結合できませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं को मर्ज करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao mesclar os alto-falantes")
	return /** @type {LocalizedString} */ ("Failed to merge speakers")
});